import React from 'react';
import PropTypes from 'prop-types';

import Immutable from 'immutable';

import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';

const withProductCompareAction = (Component)  => {
    class WithState extends React.PureComponent {

        render() {
            const { selectedProductIds, minProducts, toggleCompare, toggleProduct, compareModeActive, productId, ...rest } = this.props;

            const isSelected = selectedProductIds.includes(productId);
            const isDisabled = selectedProductIds.size >= MAX_COMPARING_PRODUCTS_NUM && !isSelected;
            const handleClick = () => {
                if (isDisabled) {
                    return;
                }
                // TOGGLE_COMPARE_MODE this status is deprecated
                // If we're in compare mode and we deselect a product, and it reaches minProducts, disable compare mode.
                if (compareModeActive && selectedProductIds.size === minProducts) {
                    // toggleCompare means enable compare mode
                    toggleCompare(false);
                }
                // Invert the current selection
                toggleProduct(!isSelected, productId);
            };

            return <Component { ...rest } productId={productId} isSelected={isSelected} isDisabled={isDisabled} onCompareClick={handleClick} />;
        }

    }

    WithState.propTypes = {
        productId: PropTypes.string.isRequired,
        selectedProductIds: PropTypes.objectOf(Immutable.List),
        minProducts: PropTypes.number,
        compareModeActive: PropTypes.bool,
        toggleCompare: PropTypes.func,
        toggleProduct: PropTypes.func
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithState);
};

const mapStateToProps = (state) => {
    const resultsConfig = resultsConfigSelector(state);
    const selectedProductIds = resultsConfig.getIn(['helpers', 'filters', 'selectedProductIds']) || Immutable.List();
    // using for active compare drawer
    const compareModeActive = resultsConfig.get('compareModeActive') || false;
    // at least 2 products was selected
    const minProducts = resultsConfig.get('minProducts') || 2;

    return {
        minProducts,
        compareModeActive,
        selectedProductIds
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleCompare: (toggle) => {
            dispatch({ type: 'TOGGLE_COMPARE_MODE', toggle });
        },
        toggleProduct: (toggle, productId) => {
            dispatch({
                type: 'TOGGLE_COMPARED_PRODUCT',
                filterValue: productId,
                toggle
            });
        }
    };
};

const MAX_COMPARING_PRODUCTS_NUM = 3;

export { withProductCompareAction, MAX_COMPARING_PRODUCTS_NUM };
